<template>
  <div class="dg__upload2" :class="{ inline: inline }">
     <!-- @click="clicktest" -->
    <div class="relative upload-box cursor-pointer">
      <div v-if="$slots.default">
        <slot></slot>
      </div>
      <div v-if="!$slots.default" class="img-upload flex">
        <i class="icon" v-show="!url">&#xe60b;</i>
        <img class="preview" :src="url" v-show="url" />
      </div>
      <input ref="fileRef" class="file-input dg__upload_input" type="file" :accept="type.toString()" @change="upfile" />
    </div>
  </div>
</template>

<script>
let hasOwnProperty = Object.prototype.hasOwnProperty;
export default {
  name: "dg-upload2",
  inject: ["elForm", "elFormItem"],
  props: {
    noUpload: Boolean,
    value: {
      type: [String, Array],
    },

    tip: String,
    buttonSize: {
      type: String,
      default: "small",
    },
    promptType: {
      type: String,
      default: ""
    },
    idInfoType: {
      type: String,
      default: ""
    },
    api: {
      type: String,
      default: "/customer/upload"
    },
    code: String,
    attrs: Object,
    size: {
      type: Number,
      default: 50,
    },
    accept: {
      type: String,
      default: "image/png, image/jpeg, image/jpg, .pdf, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
    type: {
      type: Array,
      default: () => {
        return [".jpg", ".jpeg", ".png",'.docx','.doc','.pdf'];
      },
    },
    button: Boolean,
    inline: Boolean,
  },
  data() {
    return {
      url: "",
      tips: "仅限上传一张图片，大小不超过5M",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.url = val;
      },
      immediate: true,
    },

    tip: {
      handler(val) {
        this.tips = val;
      },
      immediate: true,
    },
  },
  methods: {
    // clicktest() {
    //   this.$refs.fileRef.dispatchEvent(new MouseEvent('click'))
    // },
    /**
     * @author 伟健 / 张
     * @name 删除
     * @param
     * @return
     */
    hanldeDel() {
      if (this.url instanceof Array) {
        this.url = [];
      } else {
        this.url = "";
      }

      this.$emit("change", { url: this.url, name: "" });
      this.$emit("input", this.url);
      // if (formItem) {
      //   formItem.validate("change").catch(err => debugWarn(err));
      // }
    },
    upfile(e) {
      var file = e.target.files[0]; //获取上传的文件
      if (!file) return;
      let { size, name } = file;

      var suffix = this.getSuffix(name);
      var maxSize = 1048576 * this.size; //最大5MB
      if (size > maxSize) {
        Mirror.emit(['tips_bus'], `上传的文件不能超过${this.size}MB`);
        return;
      }
      if (this.type.length && this.type.indexOf(suffix) == -1 && this.type[0] != "*") {
        // this.$message({
        //   message: `文件类型错误,请上传${this.type.join(" ")}`,
        //   type: "error"
        // });
        // this.$emit("fileError", `文件类型错误,请上传${this.type.join(" ")}`);
        Mirror.emit(['tips_bus'], `文件类型错误,请上传${this.type.join(" ")}`);
        return;
      }
      var formData = new FormData();
      formData.append("fileName", file);
      formData.append("promptType", this.promptType);
      formData.append("idInfoType", this.idInfoType);
      this.$emit("file", file);
      if (this.noUpload) {
        return;
      }
      this.$emit("before");
      ajax.uploadFile({
        url: this.api,
        data: formData,
        self: this,
        success: (res) => {
          this.$emit("after");
          if (res) {
            if (this.api == '/llm/upload') {
              this.$emit("change", res);
              this.$emit("input", res);
            } else {
              if (this.url instanceof Array) {
                let d = { ...this.attrs };
                if (this.attrs && this.attrs["key"]) {
                  d[this.attrs["key"]] = res;
                } else {
                  d["url"] = res;
                }
                if (this.attrs && hasOwnProperty.call(this.attrs, "name")) {
                  d["name"] = file.name;
                }
                if (this.attrs && hasOwnProperty.call(this.attrs, "size")) {
                  d["size"] = file.size;
                }
                delete d["key"];
                this.url.push(d);
              } else {
                this.url = res;
              }
              this.$emit("change", { url: this.url, name: name });
              this.$emit("input", this.url);
            }


            if (this.elFormItem && this.elFormItem.prop) {
              this.elForm && this.elForm.clearValidate(this.elFormItem.prop);
            }

            // if (formItem) {
            //   formItem.validate("change").catch((err) => debugWarn(err));
            // }
          }
          Mirror.emit('tips_el_alert_box_close');
          e.target.value = "";
        },
        fail: (err) => {
          this.$emit("after");
          console.log(err);
          e.target.value = "";
          // this.$message({ message: `图片上传失败`, type: "error" });
          Mirror.emit(['tips_bus'], err.msg);
        },
      });
    },
    getSuffix(str) {
      var d = str.split(".");
      return "." + d[d.length - 1];
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.dg__upload2 {
  cursor: pointer;

  &.inline {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
  }

  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    height: 100%;
    width: 100%;
    z-index: 5;
    cursor: pointer;
    opacity: 0;
  }

  .preview {
    position: absolute;
    top: 1%;
    left: 1%;
    width: 98%;
    height: 98%;
    object-fit: cover;
    object-position: center;
    display: block;
    border-radius: 4px;
  }

  .url-box {
    width: 200px;
    color: #c7c7c7;
    font-size: 12px;
    padding-top: 5px;

    &.inline {
      width: 170px;
    }
  }

  a:hover {
    text-decoration: underline;
    color: #c7c7c7;
  }
}

.img-upload {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: 1px dashed #c7c7c7;
  cursor: pointer;

  i {
    margin: auto;
    font-size: 30px;
    color: #c7c7c7;
  }
}

.tip {
  font-size: 12px;
  color: #c7c7c7;
  padding-top: 5px;
}
</style>
